<ng-container
  fgbDataSource
  [dataSource]="games$ | async"
  [sortOptions]="sortOptions"
  [filters]="filters"
  (dataSourceChange)="dataChange.emit($event)"
>
  <ng-template let-items>
    <ng-container *ngIf="items.length > 0; else noEventsFound">
      <div class="row">
        <div *ngFor="let event of items" class="col-lg-4">
          <fgbcl-ticket-transfer-game-panel [customerTicketSummary]="event"></fgbcl-ticket-transfer-game-panel>
        </div>
      </div>
    </ng-container>
  </ng-template>
</ng-container>
<ng-template #noEventsFound>
  <!-- Find the class in the content projection and display it here for no data -->
  <ng-content select=".no-games-placeholder"></ng-content>
</ng-template>
